import { Route, Routes } from 'react-router-dom'
import { RcsRoutes } from 'pages/settings/pages/rcs/route/type'
import { RcsWizardProviderLayout } from 'pages/settings/pages/rcsV2/layout/RcsWizardProviderLayout'
import { RcsWizardRouter } from 'pages/settings/pages/rcsV2/route/RcsWizardRouter'
import { RcsPage } from 'pages/settings/pages/rcsV2/pages/rcs'

export const RcsV2Router = () => (
  <Routes>
    <Route element={<RcsWizardProviderLayout />}>
      <Route index element={<RcsPage />} />
      <Route path={`${RcsRoutes.create}/*`} element={<RcsWizardRouter />} />
    </Route>
  </Routes>
)
